export const formatDateScalarString = (date: Date | null | undefined) =>
	date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : date;
